import React from "react";
import LogRocket from "logrocket";
import logoLaddition from "../../img/logo_laddition.png";
import { Localized } from 'fluent-react/compat';

const NoRecoveryRestaurantId = () => {

  const handleLogin = () => {
    window.localStorage.clear();
    window.location.replace(window.location.pathname);
  };

  setTimeout(handleLogin, 6000);

  return (
    <div id="no-recovery-restaurantId">
      <div className="container">
        <header>
          <h1 className="logo">
            <img src={logoLaddition} alt="logo laddition" /> /{" "}
            <Localized id="tr-name-app" />
          </h1>
        </header>
        <main>
          <p>
            <Localized id="tr-general-error-1" />
          </p>
          <p>
            <Localized id="tr-general-error-2" />
          </p>
          <button onClick={handleLogin} className="is-red">
            <Localized id="tr-connect-button" />
          </button>
          <p>
            <Localized id="tr-general-error-3" />{" "}
            <a href="mailto:support@laddition.com">support@laddition.com</a>
          </p>
        </main>
      </div>
    </div>
  );
};

export default NoRecoveryRestaurantId;
